.RCACContainer
    position: relative
    height: 24px
    display: flex
    flex-direction: row
    align-items: center
    box-sizing: border-box
    border-radius: $globalButtonRounding
    .RCACControls
        display: flex
        flex-direction: row
        height: 100%
        border: 1px solid rgb($globalSettingsStrokeSecondary)
        border-radius: $globalButtonRounding
        background: rgb($globalSettingsBackgroundPrimary)
        overflow: hidden
        z-index: 2
        box-shadow: 0 3px 8px 0 rgba($globalSettingsBackgroundShadowColor,0.05)
    .RCACButton
        width: 24px
        height: 24px
        border-radius: 0
        display: flex
        justify-content: center
        align-items: center
        cursor: pointer
        overflow: hidden
        stroke: rgb($globalSettingsFontSecondary)
        &:active
            padding-top: 1px
            outline: none
        svg
            transform: scale(0.8, 0.8)
    .RCACButtonLeft
        padding-left: 3px
    .RCACButtonRight
        padding-right: 3px
    .RCACButtonRemove
        stroke: rgb($globalErrorBackground)
    .RCACButtonDisabled
        cursor: default
        stroke: rgb($globalSettingsFontTertiary)
        background: rgb($globalSettingsBackgroundTertiary)
        &:active
            padding-top: 0
            background: rgb($globalSettingsBackgroundTertiary)
        &:hover
            background: rgb($globalSettingsBackgroundTertiary)
    .RCACButtonWaved
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
        &:active
            background: rgb($globalSettingsBackgroundPrimary)
            transition: background 0s
    .RCACAmountInput
        width: 29px
        height: 100%
        color: rgb($globalSettingsFontPrimary)
        background: rgb($globalSettingsBackgroundPrimary)
        border-radius: 0
        font-size: 14px
        text-align: center
        box-sizing: border-box
        outline: none
        border: none
        &:focus
            outline: none
            background: rgb($globalSettingsBackgroundSecondary)
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
        &:disabled
            background: rgb($globalSettingsBackgroundTertiary)
            &:focus
                outline: none
                background: rgb($globalSettingsBackgroundTertiary)
            &:hover
                background: rgb($globalSettingsBackgroundTertiary)
    .RCACDeleteButton
        width: 27px
        height: 24px
        background: rgb($globalSettingsBackgroundSecondary)
        stroke: rgb($globalErrorBackground)
        overflow: hidden
        border-radius: $globalButtonRounding
        z-index: 1
        &:hover
            background: rgb($globalSettingsBackgroundTertiary)
        &:active
            background: rgb($globalSettingsBackgroundTertiary)
            transition: background 0s
    .RCACDeleteButtonWithControls
        width: 42px
        margin-right: -15px
        padding-right: 11px
    .RCACVariation
        width: 60px
        gap: 2px
        svg
            margin: 0 3px
    .RCACAmountWaiting
        position: absolute
        top: 0
        bottom: 0
        left: 0
        right: 0
        background: rgb($globalSettingsBackgroundSecondary)
        opacity: 0.5
        cursor: wait
        z-index: $indexOverlay
